/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './MonitoringSection.module.scss';

import { MonitoringFeed } from './MonitoringFeed';

type Props = {
  ctaRoute?: string;
};

export const MonitoringSection = ({ ctaRoute }: Props) => {
  const { t } = useInt();

  return (
    <Section layout="centered">
      <div className={styles.card}>
        <div>
          <TitleBlock
            align="left"
            theme="dark"
            title={t('Keep every third party monitored')}
            description={t(
              'Move any verified supplier into continuous monitoring. The moment its registry record changes — status, ownership, sanctions exposure, or an overdue filing — your risk team is alerted.',
            )}
          />

          {ctaRoute && (
            <Button type="blue" size="xl" route={ctaRoute}>
              {t('Explore perpetual monitoring')}
            </Button>
          )}
        </div>

        <MonitoringFeed />
      </div>
    </Section>
  );
};
